<template>
    <div id="bomb">
        <i class="fas fa-bomb"></i>
    </div>
</template>

<script>
    export default {
    };
</script>

<style scoped lang="scss">
    #bomb {
        height: 40px;
        width: 40px;

        text-align: center;
        line-height: 40px;
        font-size: 30px;

        box-sizing: border-box;
        padding: 2px;
        background-color: red;
    }
</style>